import { Component, OnInit } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'app-generatedSummaryReport',
    template: `
  <a (click)="downloadgeneratedSummaryReport($event)" style="color: cornflowerblue;text-decoration: underline;">{{summaryDate}}</a>`,
    standalone: false
})
export class GeneratedSummaryReport implements ICellRendererAngularComp {

  params;
  label: string;
  summaryDate

  agInit(params): void {
    this.params = params;
    this.label = this.params.label || null;
    console.log(this.params);
    this.summaryDate=this.params.data.summaryReportLastRun;
    console.log(this.summaryDate);
  }

  refresh(params?: any): boolean {
    return true;
  }

  downloadgeneratedSummaryReport($event) {
    console.log("hello")
    if (this.params.downloadgeneratedSummaryReport instanceof Function) {
      // put anything into params u want pass into parents component
      const params = {
        event: $event,
        rowData: this.params.node.data
        // ...something
      }
      console.log(params)
      this.params.downloadgeneratedSummaryReport(params);

    }
  }
}
